<template>
  <div id="updates" class="latestMedia">
    <div class="container-xl"
      v-for="video in videos"
      :key="video.id"
    >
      <div class="latest">Latest Video</div>
      <h2 class="blogTitle">{{ video.title }}</h2>
      <p>{{ video.description }}</p>
      <div class="youtubeEmbed main">
        <iframe :src="video.url" width="560" height="315" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
      </div>
    </div>
    <div class="latestBlog"
      v-for="blog in blogs"
      :key="blog.id"
    >
      <div class="latest">Latest Blog</div>
      <h2 class="blogTitle">{{ blog.title }}</h2>
      <div class="blogDate">{{ blog.date }}</div>
      <div class="blogSummary">{{ blog.summary }}</div>
    </div>
  </div>
</template>

<script>
import Videos from '@/components/Videos'
import Blog from '@/components/Blog'
import db, { Timestamp } from '@/db'

export default {
  name: 'Updates',
  components: {
    Videos,
    Blog
  },
  data () {
    return {
      videos: [],
      blogs: []
    }
  },
  created () {
    var serverTime = Timestamp.fromDate(new Date())
    db.collection('videos').orderBy('date', 'desc').where('date', '<=', serverTime).limit(1).get().then(snapshot => {
      snapshot.forEach(doc => {
        const id = doc.id
        const title = doc.data().title
        const description = doc.data().description
        const url = doc.data().url
        const urlDirect = doc.data().urlDirect

        const latestVideo = {
          id,
          title,
          description,
          url,
          urlDirect
        }

        this.videos.push(latestVideo)
      })
    })

    db.collection('blogPosts').orderBy('date', 'desc').where('date', '<=', serverTime).limit(1).get().then(snapshot => {
      snapshot.forEach(doc => {
        const id = doc.id
        const title = doc.data().title
        const blogBody = doc.data().blogBody
        var date = doc.data().date
        const summary = doc.data().summary
        const options = {
          year: 'numeric', month: 'long', day: 'numeric'
        }
        date = new Intl.DateTimeFormat('en-US', options).format(date.seconds * 1000)

        const latestBlog = {
          id,
          title,
          blogBody,
          date,
          summary
        }

        this.blogs.push(latestBlog)
      })
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Updates.vue